import ImageLoader from 'components/image-loader';
import styles from './style.module.scss';
import { useThemeContext } from 'contexts';

type LocationUnavailableProps = {
  imagePath?: string;
  message?: string;
}

export default function LocationUnavailable(
  { imagePath = '/next/assets/images/listing-page/location-unavailable.svg', 
    message = 'Location info is unavailable for now, but we\'ll update it once we have it.' } 
    : LocationUnavailableProps) {
  return (
    <div className={styles.component}>
      <div className={styles.content}>
        <ImageLoader src={imagePath} width="100%" height="100%" />
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
}
